// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-tooltip {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.input-text {
  font-size: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/text/text.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;AACF","sourcesContent":[".template-tooltip {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.input-text {\n  font-size: 1rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
